<template>
  <div class="life-navbar flex_row">
    <div
      class="life-navbar-btn flex_1 flex_center"
      v-for="item in navBarList"
      :class="item.className"
      @click="navBarClick(item)"
    >
      <div class="flex_row">
        <img :src="item.src" />
        <span>{{item.title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      authToken: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        navBarList: [
          {
            title: '历史订单',
            // path: '/lifehistory',
            path: '/historycard',
            className: 'life-navbar-order',
            src: require('../../static/images/lifePay/history_order.png')
          },
          {
            title: '咨询客服',
            path: '/customer',
            className: 'life-navbar-service',
            src: require('../../static/images/lifePay/service.png')
          }
        ]
      }
    },
    methods: {
      navBarClick({path}) {
        if (!this.authToken) {
          this.$message({
            message: "请先登录！",
            type: "warning",
          })
          return
        }
        this.$router.push({ path })
      }
    }
  }
</script>

<style lang="less" scoped>
  .life-navbar {
    max-width: 750px;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 68px;
    background-color: #fff;
    padding: 0 4px;
    margin: auto;

    .life-navbar-order {
      margin-right: 3px;
      // padding-left: 18px;

      img {
        width: auto;
        height: 29.75px;
      }
    }

    .life-navbar-service {
      // padding-left: 24px;

      img {
        width: auto;
        height: 26px;
      }
    }

    .life-navbar-btn {
      height: 44px;
      background: linear-gradient(180.00deg, #ED3A42, #B92229 100%);
      box-shadow: inset 0px -0.5px 0px rgb(226, 227, 228);
      border-radius: 6px;

      img {
        margin-right: 12px;
      }

      span {
        font-family: 思源黑体;
        font-size: 24px;
        color: #fff;
        font-weight: 700;
        line-height: 24px;
        margin-top: -2px;
        letter-spacing: 0.2px;
      }
    }
  }

  @media (max-width: 374px) {
    .life-navbar-btn {
      span {
        font-size: 18px !important;
      }
    }

    .life-navbar-order {
      img {
        height: 24px !important;
      }
    }

    .life-navbar-service {
      img {
        height: 22px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lifeNavBar.vue